import { jsx } from "react/jsx-runtime";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import ErrorBoundary from "../ErrorBoundary.js";
import { theme } from "./theme.js";
import "react";
import "@mui/material/styles";
import "../constants.js";
import "../utils.js";
import "./Palette/paletteTheme.js";
import "./Typography/theme.js";
function MUIThemeProvider({
  children
}) {
  return /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(ThemeProvider, { theme, children }) });
}
export {
  MUIThemeProvider
};
//# sourceMappingURL=ThemeProvider.js.map
